import React, { RefObject } from 'react';
import 'twin.macro';
import { Field, useField } from 'react-final-form';
import {
  BILAN_EVENT,
  CLASSIC_EVENT,
  RAPPEL_EVENT,
} from '@teetsh/app/src/containers/constants';
import { ClassicBody } from 'containers/CahierJournal/EventModal/ModalBody/Classic';
import Editor from '@teetsh/app/src/components/Editor/formWrapper';
import { AttachmentComponent as Attachments } from 'components/Attachments/Attachment';
import { useTranslation } from 'react-i18next';
import { AteliersBody } from './Ateliers';
import { CJAtelier } from 'types/cj';
import tw from 'twin.macro';

export interface Props {
  type: string;
  materialInputRef?: RefObject<HTMLInputElement>;
  attachmentInputRef?: RefObject<HTMLInputElement>;
  customFieldsInputRefs?: RefObject<HTMLInputElement[]>;
  ateliersRef?: RefObject<HTMLDivElement>;
  cycle?: string;
  onAddToSeanceCallback?: () => void;
}

export function ModalEventCJBody(props: Props) {
  const {
    type,
    materialInputRef,
    attachmentInputRef,
    customFieldsInputRefs,
    cycle,
    ateliersRef,
    onAddToSeanceCallback,
  } = props;
  const { t } = useTranslation(['cahierJournal']);
  const ateliersField = useField<CJAtelier[]>('ateliers');

  if (type === RAPPEL_EVENT || type === BILAN_EVENT) {
    return (
      <div tw="flex flex-col gap-y-6">
        <Field
          name="flow"
          label={t('cahierJournal:seance.modal.reviewOfTheDay')}
          component={Editor}
          placeholder={
            type === RAPPEL_EVENT
              ? t('cahierJournal:labels.rappelFlowPlaceholder')
              : type === BILAN_EVENT
              ? t('cahierJournal:labels.bilanFlowPlaceholder')
              : undefined
          }
        />
        <Field
          name="attachments"
          render={({ input: { onChange, value } }) => (
            <Attachments
              inputRef={attachmentInputRef}
              attachments={value}
              onChange={onChange}
            />
          )}
        />
      </div>
    );
  }

  // users can switch between Classic and Break, but DO NOT early return null for Break, otherwise the user would lose the form state
  return (
    <div
      css={[tw`hidden`, type === CLASSIC_EVENT && tw`flex flex-col gap-y-6`]}
    >
      <ClassicBody
        cycle={cycle}
        customFieldsInputRefs={customFieldsInputRefs}
        materialInputRef={materialInputRef}
        attachmentInputRef={attachmentInputRef}
        onAddToSeanceCallback={onAddToSeanceCallback}
      />
      {(ateliersField?.input?.value || []).length > 0 && (
        <div ref={ateliersRef}>
          <AteliersBody cycle={cycle} />
        </div>
      )}
    </div>
  );
}
